export const HEADERS: TableHeader[] = [
	{
		label: 'Title',
		key: 'TITLE',
		classNames: "w-[400px] max-w-[400px]"
	},
	{
		label: 'Author',
		key: 'AUTHOR',
	},
	{
		label: 'Category',
		key: 'CATEGORY',
	},
	{
		label: 'Venue',
		key: 'VENUE',
	},
	{
		label: 'Status',
		key: 'STATUS',
	},
	{
		label: 'Action',
		key: 'ACTION',
	},
];


export const OPTION_FILTER_STYLE = {
	true: {
		button: 'bg-blue-light text-white',
		pill: 'bg-blue-lighter',
	},
	false: {
		button: 'text-grey-dark',
		pill: 'bg-grey-subtle',
	},
};

export const FILTER = {
	ALL: {
		id: 'ALL',
		name: 'Semua',
		total: 0,
	},
	PUBLISHED: {
		id: 'PUBLISHED',
		name: 'Published',
		total: 0,
	},
	DRAFT: {
		id: 'DRAFT',
		name: 'Draft',
		total: 0,
	},
	ARCHIEVED: {
		id: 'ARCHIVED',
		name: 'Archived',
		total: 0,
	},
};

export const FILTER_KEYS = Object.keys(FILTER);

export const TOTAL_OPTION_FITLER = FILTER_KEYS.length;